var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "#F1F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7694 14.7761C24.7694 16.6778 23.2686 18.2262 21.4254 18.2262H3.23096V4.56148C3.23096 2.65982 4.7318 1.11133 6.57495 1.11133H24.7694V14.7761V14.7761Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8447 11.2708H20.2271C20.2666 11.2708 20.3587 11.2572 20.3982 11.2572C20.6615 11.2029 20.8854 10.9584 20.8854 10.6188C20.8854 10.2928 20.6615 10.0483 20.3982 9.98038C20.3587 9.9668 20.2797 9.9668 20.2271 9.9668H18.8447V11.2708Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0694 2.26563C18.7529 2.26563 17.6733 3.36587 17.6733 4.73778V7.30502H21.0568C21.1358 7.30502 21.228 7.30502 21.2938 7.3186C22.0574 7.35935 22.6235 7.76685 22.6235 8.47318C22.6235 9.03009 22.2417 9.5055 21.5308 9.60059V9.62775C22.3075 9.68209 22.9 10.1303 22.9 10.8231C22.9 11.5702 22.2417 12.0592 21.3728 12.0592H17.6602V17.085H21.1753C22.4918 17.085 23.5714 15.9847 23.5714 14.6128V2.26563H20.0694V2.26563Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7142 8.63673C20.7142 8.31073 20.4904 8.0934 20.2271 8.05265C20.2008 8.05265 20.1349 8.03906 20.0954 8.03906H18.8447V9.23439H20.0954C20.1349 9.23439 20.2139 9.23439 20.2271 9.22081C20.4904 9.18006 20.7142 8.96272 20.7142 8.63673V8.63673Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82527 2.26563C5.50874 2.26563 4.42918 3.36587 4.42918 4.73778V10.8367C5.10061 11.1762 5.79837 11.3936 6.49614 11.3936C7.32555 11.3936 7.77317 10.8774 7.77317 10.1711V7.29143H9.82696V10.1575C9.82696 11.2713 9.15553 12.1814 6.87793 12.1814C5.49557 12.1814 4.41602 11.869 4.41602 11.869V17.0714H7.93116C9.24769 17.0714 10.3272 15.9711 10.3272 14.5992V2.26563H6.82527V2.26563Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4474 2.26563C12.1308 2.26563 11.0513 3.36587 11.0513 4.73778V7.9706C11.6569 7.44085 12.7101 7.10127 14.4084 7.18277C15.3168 7.22352 16.2911 7.4816 16.2911 7.4816V8.52751C15.8039 8.26943 15.2247 8.03851 14.4743 7.98418C13.1841 7.8891 12.4073 8.54109 12.4073 9.68209C12.4073 10.8367 13.1841 11.4887 14.4743 11.38C15.2247 11.3257 15.8039 11.0812 16.2911 10.8367V11.8826C16.2911 11.8826 15.33 12.1407 14.4084 12.1814C12.7101 12.2629 11.6569 11.9233 11.0513 11.3936V17.0986H14.5664C15.8829 17.0986 16.9625 15.9983 16.9625 14.6264V2.26563H13.4474V2.26563Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.6708,
    y1: 10.6204,
    x2: 23.587,
    y2: 10.6204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.6709,
    y1: 9.66936,
    x2: 23.5875,
    y2: 9.66936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.6707,
    y1: 8.63503,
    x2: 23.587,
    y2: 8.63503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4.42639,
    y1: 9.66936,
    x2: 10.4341,
    y2: 9.66936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11.0172,
    y1: 9.66936,
    x2: 16.8521,
    y2: 9.66936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCard);
export default __webpack_public_path__ + "static/media/jcb-card.b006f9e488f92fe7801b1eb1d3248d9b.svg";
export { ForwardRef as ReactComponent };